import { Typography, Button, Stack } from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"
import AddAssignmentModal from "./AddAssignmentModal"
import AddQuizModal from "./AddQuizModal"
import AddTestModal from "./AddTestModal"

const ChooseAssignmentTypeModal = (props) => {
  const [choiceModalStates, setChoiceModalStates] = useState([
    false,
    false,
    false,
  ])
  const openChoiceModal = (idx) =>
    setChoiceModalStates([
      ...choiceModalStates.slice(0, idx),
      true,
      ...choiceModalStates.slice(idx + 1),
    ])
  const closeChoiceModal = (idx) =>
    setChoiceModalStates([
      ...choiceModalStates.slice(0, idx),
      false,
      ...choiceModalStates.slice(idx + 1),
    ])
  const choices = [
    {
      title: "Assignment",
      desc: "Share homework assignments with your batch.",
    },
    {
      title: "Online Quiz",
      desc: " Create your own customized quiz. Includes MCQs as well as subjective questions.",
    },
    {
      title: "Pen & Paper Test",
      desc: "Old school. Students solve your test paper and then submit their scanned answer scripts within the time limit.",
    },
  ]
  return (
    <>
      <Modal {...props} title="Choose Assignment Type" noActions maxWidth="md">
        <Stack direction="row" spacing={2}>
          {choices.map((choice, i) => (
            <Choice key={i} {...choice} action={() => openChoiceModal(i)} />
          ))}
        </Stack>
      </Modal>
      <AddAssignmentModal
        isOpen={choiceModalStates[0]}
        close={() => closeChoiceModal(0)}
      />
      <AddQuizModal
        isOpen={choiceModalStates[1]}
        close={() => closeChoiceModal(1)}
      />
      <AddTestModal
        isOpen={choiceModalStates[2]}
        close={() => closeChoiceModal(2)}
      />
    </>
  )
}

const Choice = ({ title, desc, action }) => (
  <Button
    onClick={action}
    sx={{ flexDirection: "column", textTransform: "none" }}
    variant="contained"
    fullWidth
  >
    <Typography variant="h5">{title}</Typography>
    <Typography variant="body1">{desc}</Typography>
  </Button>
)

export default ChooseAssignmentTypeModal
